import { Badge } from "@fluentui/react-components";
import type { TicketStatus } from "../api/tickets";

const colorMap: Record<TicketStatus, "success" | "warning" | "informative" | "subtle" | "danger"> = {
  Unread: "danger",
  Open: "success",
  "With User": "warning",
  "In Progress": "warning",
  Pending: "warning",
  Resolved: "informative",
  Closed: "subtle",
};

export default function StatusBadge({ status }: { status: TicketStatus }) {
  return (
    <Badge appearance="filled" color={colorMap[status] ?? "subtle"} size="small">
      {status}
    </Badge>
  );
}
